/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {NgswCommChannel as Éµangular_packages_service_worker_service_worker_a} from './src/low_level';
export {SCRIPT as Éµangular_packages_service_worker_service_worker_b,ngswAppInitializer as Éµangular_packages_service_worker_service_worker_c,ngswCommChannelFactory as Éµangular_packages_service_worker_service_worker_d} from './src/module';